import BaseManager from "./BaseManager";
import Facade from "@/Facade";
import '../externals/ppb-game-client-api-1.0.8'
import Signals from "@/signals/GameSignals";

export const BETFAIR_POST_MESSAGE_TYPES = {
    GAME_LOAD_STARTED: 'gameLoadStarted',
    GAME_LOAD_PROGRESS: 'gameLoadProgress',
    GAME_LOAD_COMPLETED: 'gameLoadCompleted',
    GAME_ANIMATION_START: 'gameAnimationStart',
    GAME_ANIMATION_COMPLETED: 'gameAnimationCompleted',
    REQUEST_GAME_WINDOW_CONFIG: 'requestGameWindowConfig',
    BALANCE_UPDATE: 'balanceUpdate',
    STAKE_UPDATE: 'stakeUpdate',
    WIN_UPDATE: 'winUpdate',
    JACKPOT_WIN_UPDATE: 'jackpotWinUpdate',
    GAMING_SESSION_DETAILS: 'gamingSessionDetails',
    toggleMenu: 'toggleMenu',
    SETTINGS_UPDATE: 'settingsUpdate',
    ERROR_MESSAGE: 'errorMessage',
    SEND_EVENT: 'sendEvent',
    GO_TO_GAME: 'goToGame',
    SESSION_DETAILS_MESSAGE: 'sessionDetailsMessage',
    PLAY_MODE_UPDATE: 'playMode',
    OPEN_DEPOSIT: 'openDeposit',
}

export const BETFAIR_RECEIVE_MESSAGE_TYPES = {
    BALANCE_CHANGED: 'balanceChanged',
    SETTINGS_UPDATE: 'settingsUpdate',
    TOGGLE_PAYTABLE: 'togglePaytable',
    NOTIFY_ACTION: 'notifyAction',
    RECEIVE_GAME_WINDOW_CONFIG: 'receiveGameWindowConfig',
    REGISTER_CALLBACK_FUNCTION: 'registerCallbackFunction',
    SET_MESSAGING_EVENT_TARGET: 'setMessagingEventTarget',
    STOP_AUTO_SPIN: 'stopAutoSpin',
    LAUNCH_GAME_DETAILS: 'launchGameDetails',
}

export const BETFAIR_PLAY_MODES = {
    NORMAL: 'normal',
    AUTO_SPIN: 'autoSpin',
    FREE_SPIN: 'freeSpin',
    BONUS_ROUND: 'bonusRound',
}

export default class BetfairManager extends BaseManager {
    loadingStarted = false;
    autoSpinsActive = false;
    currentState = null;
    BALANCE_MULTIPLIER = 100;

    constructor() {
        super()
    }

    init(adapter) {
        super.init(adapter)
    }

    relaxConfigure(data) {
        this.gc = window.com.ppb.gc;
        this.gcRegisterCallbackFunction = this.gc.registerCallbackFunction;

        console.log("BETFAIR" , data);
        this.currency = data.currency

        //ON BALANCE CHANGE
        this.gcRegisterCallbackFunction(BETFAIR_RECEIVE_MESSAGE_TYPES.BALANCE_CHANGED, () => {
            this.adapter.updateBalance()
        })

        //ON TOGGLE PAYTABLE
        this.gcRegisterCallbackFunction(BETFAIR_RECEIVE_MESSAGE_TYPES.TOGGLE_PAYTABLE, () => {
            this.adapter.togglePaytable()
        })

        //ON STOP AUTOSPINS
        this.gcRegisterCallbackFunction(BETFAIR_RECEIVE_MESSAGE_TYPES.STOP_AUTO_SPIN, () => {
            this.adapter.stopAutospins()
            this.stopAutoSpins()
        })

        //ON SETTINGS UPDATE
        this.gcRegisterCallbackFunction(BETFAIR_RECEIVE_MESSAGE_TYPES.SETTINGS_UPDATE, (payload) => {
            if (payload.settingName === 'sound') {
                this.adapter.setAudio(payload.settingValue)
            }
            if (payload.settingName === 'fastPlay') {
                this.adapter.setTurboMode(payload.settingValue)
            }
        })
    }

    loadProgress(progress) {
        if (!this.loadingStarted) {
            this.loadingStarted = true
            this.gc.sendGameLoadStarted();
        }

        this.gc.sendGameLoadProgress(progress);
    }

    loadCompleted() {
        this.gc.sendGameLoadCompleted();
        this.balanceUpdate(Facade.model.balance)
        this.sendPlayMode()

        if(Facade.urlParams.customer === "betfair_test" || Facade.urlParams.customer === 'betfair'){
            this.adapter.disableGamePopups();
        }
    }

    sendPlayMode() {
        let currentState = BETFAIR_PLAY_MODES.NORMAL

        if (this.autoSpinsActive) {
            currentState = BETFAIR_PLAY_MODES.AUTO_SPIN
        }

        if (this.currentState === currentState) return

        this.currentState = currentState

        this.gc.sendPlayModeUpdate(currentState)
    }

    audioToggle(state) {
        this.gc.sendSettingsUpdate('sound', state ? 'on' : 'off')
    }

    roundStart(value = 0) {
        this.gc.sendGameAnimationStart()
        this.gc.sendWinUpdate(0, this.currency)
        this.balanceUpdate(value)
    }

    roundEnd({balance = 0, totalBet = 0, totalWin = 0}) {
        this.gc.sendWinUpdate(this.toWhole(totalWin), this.currency)
        this.balanceUpdate(balance);
        this.gc.sendGameAnimationCompleted()
    }

    //DUPLICATE OF BET UPDATE
    stakeUpdate(data) {
    }

    betUpdate(data) {
        this.gc.sendStakeUpdate(this.toWhole(data), this.currency);
    }

    autoPlayStarted() {
        this.autoSpinsActive = true
        this.sendPlayMode()
    }

    autoplayFinished() {
        this.autoSpinsActive = false
        this.sendPlayMode()
    }

    stopAutoSpins() {
        this.autoplayFinished()
        this.adapter.stopAutospins()
    }

    closed() {
        this.gc.sendEvent('exitGame')
    }

    errorMessage(data) {
        console.log("::: BETFAIR SEND ERROR", data)
        this.gc.sendErrorMessage(data.message, data.title)
    }

    balanceUpdate(value) {
        this.gc.sendBalanceUpdate({
            realAmount: this.toWhole(value),
            bonusAmount: 0,
        }, this.currency)
    }

    toWhole(value) {
        return parseFloat((value / this.BALANCE_MULTIPLIER).toFixed(2))
    }
}
